import { StringToBool } from "./StringToBool";

export function AutoLoginState() {
  var doautologin = localStorage.autologin;
  if (doautologin == null) doautologin = false;
  else doautologin = StringToBool(doautologin);
  return doautologin;
}
